<template>
  <section class="homeSkeleton">
    <section class="homeSkeleton-main">
      <skeleton-video show-controllers />
    </section>
    <section class="homeSkeleton-sidebar">
      <skeleton-video show-controllers />
      <skeleton-video show-controllers />
    </section>
  </section>
</template>
<script>
export default {
  name: 'HomeSkeleton',
};
</script>

<style lang="scss">
.homeSkeleton {
  position: absolute;
  aspect-ratio: 16/9;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &-main {
    width: 70%;
    margin-right: 20px;
  }
  &-sidebar {
    height: 50%;
    width: 30%;
  }
}
</style>
